import { isEmpty } from 'lodash';
import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { NoteField as NoteFieldT } from 'components/organisms/tasks/fields';

const number_of_line_to_display = 3;
const Wrapper = styled.span<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  min-height: var(--input-height-default);
  padding: var(--spacing-03) var(--spacing-05);
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  .note-field-value {
    min-height: 0;
    max-height: calc(
      var(--line-height-base) * ${number_of_line_to_display + 1}
    );
    .ck.ck-content {
      padding: 0px !important;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${number_of_line_to_display};
      min-height: 0;
      max-height: calc(
        var(--line-height-base) * ${number_of_line_to_display + 1}
      );
    }
  }
`;

interface FieldProps {
  field: NoteFieldT;
  open?: (field: NoteFieldT) => void;
  disabled: boolean;
}

export const NoteField: FC<FieldProps> = ({ field, open, disabled }) => {
  const formattedValue = useMemo(
    () => (field.value ?? '').toString().replaceAll('\n', '<br>'),
    [field.value],
  );

  return (
    <Wrapper
      onClick={() => open?.(field)}
      className="note-field"
      disabled={disabled}
    >
      {field.value != null && !isEmpty(field.value) ? (
        <RichTextEditor
          className="note-field-value"
          data={formattedValue}
          disallowMentions
          testId={`right.content.note.${field.fieldLabel}`}
          noVariables
          readonly
        />
      ) : (
        <>—</>
      )}
    </Wrapper>
  );
};
